
import { ReactNode, useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Container, OffcanvasBody, OffcanvasHeader, Row, Table } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenCabysSearchPubSub, OpenCabysSearchPubSubPayload } from "@utils/pubsubs/PubSub";
import { ClientDataType } from "@/api/ClientApi";
import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import SearchIdentificacionForm, { CABYS_TEXT_FILTER_CODE } from "./form";
import { CabysItem, HaciendaApi } from "@/atv/HaciendaApi";
import { showAlert } from "@utils/Alert";
import LoadingScreen from "@components/content/LoadingScreen";
import { HiddenableContainer } from "@components/layout/HiddenableContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { ProductDataType } from "@/api/ProductsApi";
import { IVA_TAX_TYPE, TAXES_PERCENTAGES_CODE_BY_PERCENTAGE } from "@utils/Constants";
import { productTypeFromCabys } from "@utils/Cabys";

type CabysSearchFormData = {
    tipoFiltro: string
    filtro: string
}

type SearchCabysOffCanvasProps = {
    onCabysSelected: (productData?: ProductDataType) => void
} & DefaultOffCanvasProps

const SearchCabysOffCanvas = (props: SearchCabysOffCanvasProps) => {
    const { btnColor = "primary", className, onCabysSelected } = props;
    const [isOpen, setOpen] = useState(false);
    const formRef = useRef<DynamicFormRef>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [searchDone, setSearchDone] = useState<boolean>(false);
    const [cabysList, setCabysList] = useState<CabysItem[]>();

    useEffect(() => {
        const unsubscribe = OpenCabysSearchPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenCabysSearchPubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
    }


    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        OpenCabysSearchPubSub.publish({ openOffCanvas: false })
    }

    const searchCabys = async (formData: CabysSearchFormData) => {
        try {
            setIsLoading(true)
            setSearchDone(true)
            if (formData.tipoFiltro == CABYS_TEXT_FILTER_CODE) {
                const { cabys } = await HaciendaApi.searchCabys(formData.filtro)
                setCabysList(cabys)
            } else {
                const cabys = await HaciendaApi.getCabysByCodigo(formData.filtro)
                setCabysList(cabys)
            }
        } catch (err) {
            if (err instanceof Error) {
                showAlert("danger", "No se encuentra para el filtro ingresado");
                setCabysList([]);
            }
        } finally {
            setIsLoading(false)
        }

    }

    const triggerCabysSelection = (cabys: CabysItem) => {
        const productData: ProductDataType = {
            codigo_cabys: cabys.codigo,
            tipo_impuesto: IVA_TAX_TYPE,
            porcentaje_impuesto: TAXES_PERCENTAGES_CODE_BY_PERCENTAGE[cabys.impuesto],
            tipo_producto: productTypeFromCabys(cabys.codigo)
        }
        onCabysSelected(productData)
        resetForm()
    }
    const resetForm = () => {
        onCanvasClosed()
        formRef.current?.resetFormValue()
        setCabysList([])
    }

    const renderCabysOptions = (): ReactNode | null => {
        if (cabysList && cabysList?.length > 0) {
            return cabysList.map(c => {
                return (
                    <tr>
                        <td>
                            {c.codigo}
                        </td>
                        <td>
                            {c.descripcion}
                        </td>
                        <td>
                            {c.impuesto}%
                        </td>
                        <td>
                            <Button type="button" onClick={() => { triggerCabysSelection(c) }} color="success">
                                <FontAwesomeIcon className="me-2" icon={faCheck} />  Seleccionar
                            </Button>
                        </td>
                    </tr>
                )
            })
        }
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Buscar Cabys de Producto
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <DynamicForm<CabysSearchFormData>
                            ref={formRef}
                            id="statusForm"
                            formConfig={SearchIdentificacionForm}
                            onSubmit={searchCabys}
                        >
                        </DynamicForm>

                        <HiddenableContainer show={!!(cabysList && cabysList?.length > 0)}>
                            <Row className="mt-3">
                                <Col>
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th>Codigo</th>
                                                <th>Descripcion</th>
                                                <th>% Impuesto</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {renderCabysOptions()}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </HiddenableContainer>

                        {searchDone && !(cabysList && cabysList?.length > 0) && (
                            <Alert className="mt-3" color="warning">
                                No hay ninguna cabys para el filtro ingresado
                            </Alert>
                        )
                        }
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >

            <LoadingScreen isLoading={isLoading} />
        </>
    );
}
export default SearchCabysOffCanvas;
